import appApi from "@/api/appApi";
import { toFormData, multipartHeaders } from "@utils/queries";

export default {
  async getOwnTeam() {
    const { data } = await appApi.get("/team/own");
    return data;
  },

  async getTeamDetails(id) {
    const { data } = await appApi.get(`/team/view?id=${id}`);
    return data;
  },

  async getTeams({ page, city_id }) {
    const { data } = await appApi.get(
      `/team/index?city_id=${city_id}&page=${page}`
    );
    return data;
  },

  async createTeam({ name, city_id, file }) {
    const formData = toFormData({ name, city_id, file });
    const { data } = await appApi.post(
      "/team/create",
      formData,
      multipartHeaders
    );
    return data;
  },

  async updateTeam({ file, city_id }) {
    const formData = toFormData({ city_id, file });
    const { data: result } = await appApi.post(
      "/team/update",
      formData,
      multipartHeaders
    );
    if (result.success) {
      result.data.city_id = +result.data.city_id;
    }
    return result;
  },

  async addMember({
    email,
    password,
    first_name,
    middle_name,
    last_name,
    mobile_number,
    type,
    birthday
  }) {
    const { data } = await appApi.post("/team/add-player", {
      email,
      password,
      first_name,
      middle_name,
      last_name,
      mobile_number,
      type,
      birthday
    });
    return data;
  },

  async updateMember(playerData) {
    const { data } = await appApi.post(
      `/team/edit-player?player_id=${playerData.id}`,
      playerData
    );
    return data;
  }
};
